import React, { useState } from "react";

import { ChevronDown } from "lucide-react";

import "./Faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqItems = [
    {
      question: "Phí rút đáo thẻ tín dụng là bao nhiêu?",

      answer:
        "Mức phí rút và đáo thẻ tín dụng chỉ từ 1,1%, tùy thuộc vào loại thẻ, và số tiền khách hàng muốn rút. Nhân viên sẽ tư vấn và báo phí chính xác trước khi thực hiện giao dịch.",
    },

    {
      question: "Có hỗ trợ rút tiền tại nhà không?",

      answer:
        "Chúng tôi hỗ trợ khách hàng tại nhà, văn phòng và các địa điểm thuận tiện theo khu vực phục vụ. Quý khách vui lòng liên hệ hotline để được tư vấn và xác nhận thời gian hỗ trợ.",
    },

    {
      question: "Mất bao lâu để nhận được tiền?",

      answer:
        "Thời gian xử lý thông thường khoảng 3 phút sau khi hoàn tất các bước xác nhận giao dịch. Thời gian thực tế có thể thay đổi tùy vào phương thức giao dịch.",
    },

    {
      question: "Có giữ thẻ hoặc lưu thông tin thẻ không?",

      answer: "Khách hàng được trực tiếp kiểm tra và xác nhận giao dịch. ",
    },

    {
      question: "Có rút được toàn bộ hạn mức thẻ không?",

      answer: "Có, tùy vào nhu cầu quý khách!",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        {/* SECTION HEADING */}

        <div className="faq-heading">
          <h2>CÂU HỎI THƯỜNG GẶP</h2>

          <p>Giải đáp nhanh những thắc mắc phổ biến</p>
        </div>

        {/* FAQ GRID */}

        <div className="faq-grid">
          {faqItems.map((item, index) => (
            <div
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              key={index}
            >
              {/* QUESTION */}

              <button
                type="button"
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <span>{item.question}</span>

                <ChevronDown className="faq-arrow" size={20} strokeWidth={2} />
              </button>

              {/* ANSWER */}

              <div
                id={`faq-answer-${index}`}
                className="faq-answer"
                hidden={activeIndex !== index}
              >
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
